<template>
  <div class="newsList">
    <div :style="{ background: 'url('+ banner +')' }" class="banner"></div>
    <div class="classification publick">
      <li v-for="(item,index) in classifications.type" :class=" index === classificationIndex ? 'choice':'' "
          :key="index" @click="classification(index,item.id)" class="fl">{{item.name}}
      </li>
    </div>
    <div class="list publick">
      <div class="listLeft fl">
        <li v-for="(item,index) in list.data" :key="index">
          <router-link :to="{ path: '/newsDetails', query: { id: item.id } }">
            <div class="img fl"><img :src="item.cover" width="115" alt=""></div>
            <div class="h5 line-clamp-1 fr">{{item.title}}</div>
            <div class="dec line-clamp-1 fr">{{item.describe}}</div>
            <div class="look fr">
              <img src="./look.png" alt=""> {{item.read_num}}
            </div>
          </router-link>
        </li>
      </div>
      <div class="consulting fr">
        <consulting :spnews="spnews"></consulting>
      </div>
    </div>

    <div style="clear: both;"></div>
    <div class="page publick">
      <el-pagination
        background
        layout="prev, pager, next"
        @current-change="pageChange"
        :total="list.count">
      </el-pagination>
    </div>
  </div>
</template>

<script>
  import consulting from '@/components/news/consulting/consulting'

  export default {
    components: {
      consulting
    },
    data () {
      return {
        classifications: ['全部', '经验分享', '行业动态', '早教话题', '早教话题', '新品牌', '名师介绍'],
        classificationIndex: 0,
        page: 1,
        typeId: 0,
        banner: '',
        list: {},
        spnews: {}
      }
    },
    created () {
      this.getType()
      this.getList()
      this.getSpnews()
    },
    methods: {
      classification (index, typeId) {
        this.classificationIndex = index
        this.typeId = typeId
        this.page = 1
        this.getList()
      },
      pageChange (page) {
        this.page = page
        this.getList()
      },
      getType () {
        this.$http.post('/apipx/News/type', {
          token: JSON.parse(localStorage.getItem('login')).token
        }).then(res => {
          if (res.code === 0) {
            this.classifications = res.data
            this.classifications.type.unshift({
              id: 0,
              name: '全部'
            })
            this.banner = res.data.banner[0].src
          }
        })
      },
      getList () {
        this.$http.post('/apipx/News/lists', {
          type_id: this.typeId,
          p: this.page,
          row: 10,
          token: JSON.parse(localStorage.getItem('login')).token
        }).then(res => {
          if (res.code === 0) {
            this.list = res
          }
        })
      },
      getSpnews () {
        this.$http.post('/apipx/News/spnews', {
          token: JSON.parse(localStorage.getItem('login')).token
        }).then(res => {
          if (res.code === 0) {
            this.spnews = res.data
          }
        })
      }
    }
  }
</script>

<style type="text/scss" lang="scss">
  .newsList {

    .banner {
      width: 100%;
      height: 350px;
      background: url("banner.jpg") no-repeat center center;
    }

    .classification {
      overflow: hidden;
      margin: 40px auto;

      li {
        padding: 0 15px;
        height: 35px;
        float: left;
        margin: 15px;
        line-height: 35px;
        border-radius: 20px;
        cursor: pointer;

        &.choice {
          background-color: #ff8484;
          color: #fff;
        }
      }
    }

    .list {
      margin: 40px auto 0;

      .listLeft {
        width: 700px;
        padding: 35px;
        box-shadow: 0px 0px 20px #f6f6f6;
        overflow: hidden;

        li {
          overflow: hidden;
          margin-top: 20px;

          &:first-child {
            margin: 0;
          }

          .img {
            width: 115px;
            border-radius: 5px;
            overflow: hidden;
          }

          .h5 {
            width: 560px;
            font-size: 18px;
            color: #535353;
            margin-top: 15px;
          }

          .dec {
            width: 560px;
            font-size: 14px;
            color: #535353;
            margin-top: 15px;
          }

          .look {
            width: 560px;
            height: 25px;
            line-height: 25px;
            overflow: hidden;
            font-size: 12px;
            color: #b3b3b3;
            border-bottom: 1px solid #ebebeb;
            padding-bottom: 20px;
            margin-top: 21px;

            img {
              width: 18px;
              height: 18px;
              display: block;
              float: left;
              margin: 2.5px 10px 0 0;
            }
          }
        }
      }
    }

    .page {
      height: 35px;
      margin: 50px auto;

      .el-pagination {
        width: 500px;
        margin: 0 auto;
      }

      .el-pagination.is-background .btn-next, .el-pagination.is-background .btn-prev, .el-pagination.is-background .el-pager li {
        border-radius: 50%;
        min-width: 33px;
        min-height: 33px;
        line-height: 33px;
        margin: 0 8px;

        &:hover {
          color: #ff8484;
        }
      }

      .el-pagination.is-background .el-pager li:not(.disabled).active {
        background-color: #ff8484;
        color: #FFF;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/news/list/list.vue